import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const CustomModal = props => (
  <Modal
    isOpen={props.openModal}
    toggle={props.cancelEvent}
    className={"custom-modal-container " + props.className}
    size={props.size}
    backdrop={props.backdrop ? props.backdrop : true}
  >
    <ModalHeader toggle={props.cancelEvent}>{props.title}</ModalHeader>
    <ModalBody>{props.modalBodyContent}</ModalBody>
    {!props.noFooterButtons && (<ModalFooter>
        <React.Fragment>
          {!props.useOneButton && (
            <React.Fragment>
              <button
                className="insta-button-primary"
                onClick={props.okayEvent}
              >
                {props.okayText}
              </button>
              &nbsp;&nbsp;
            </React.Fragment>
          )}
          <button className="insta-button-primary" onClick={props.cancelEvent}>
            {props.cancelText}
          </button>
        </React.Fragment>
      </ModalFooter>
    )}
  </Modal>
);

export default CustomModal;

CustomModal.defaultProps = {
  okayText: "OKAY",
  cancelText: "CANCEL",
  modalBodyContent: "",
  openModal: false,
  className: "",
  useOneButton: false,
  noFooterButtons: false
};

CustomModal.propTypes = {
  title: PropTypes.string,
  okayText: PropTypes.string,
  cancelText: PropTypes.string,
  modalBodyContent: PropTypes.any,
  okayEvent: PropTypes.func,
  cancelEvent: PropTypes.func,
  openModal: PropTypes.bool,
  className: PropTypes.string,
  useOneButton: PropTypes.bool,
  noFooterButtons: PropTypes.bool
};
